import { Container, Row, Col } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import Counter from "../components/sections/counter";
// import Placement from "../components/sections/placement";


import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Sathishkumar from "../assets/images/about-us/Sathishkumar.png";

import saran from "../assets/images/about-us/saran.png";
import swetha from "../assets/images/about-us/swetha.png";



import useCustom from "../hooks/useCustom";

import vision from "../assets/images/vission.svg";
import mission from "../assets/images/mission.svg";
// New package flip-card
import { FlipCard } from '@veeyaainnovatives/flip-card';

const AboutUs = () => {

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const {
    whyChoose,
    homeCounterValue,
  } = useCustom();



  return (
    <div className="body-wrap  overflow-hidden">
      <Container>
        <h1 className="about-us-title text-center my-md-5 my-4">About <span className="theme-color-green">Sathiesh Design Studio</span></h1>
        <div className="pt-4">
          <Row>
            {/* <Col lg={6}>
              <div className="enroll-banner-wrap mb-4 mb-lg-0">
                <div style={{ backgroundImage: `url(${bookaseatbanner}` }} alt="enroll-img" className="enroll-banner" />

              </div>
            </Col> */}
            <Col lg={12}>
              <div className="mt-3 mt-lg-0"></div>
              <p className="Enroll-timing-details">  Sathiesh Design Studio is Chennai’s first Single-Window Online Approval + Design–Build Studio, integrating architecture, interiors, construction, structural engineering, valuation, and 3D VR/AR into one seamless system.</p>

              <Row className="mb-5 about-no-design">
                <Col md={3} xs={6}>
                  <div className="icon-circle"><span className="fas fa-users-slash" /></div>
                  <p>No Outsourcing</p>
                </Col>
                <Col md={3} xs={6}>
                  <div className="icon-circle"><span className="fas fa-circle-question" /></div>
                  <p>No Confusion</p>
                </Col>
                <Col md={3} xs={6}>
                  <div className="icon-circle"><span className="fas fa-clock-rotate-left" /></div>
                  <p>No Delays</p></Col>
                <Col md={3} xs={6}>
                  <div className="icon-circle"><span className="fas fa-eye-slash" /></div>
                  <p>No Hidden Cost</p>
                </Col>
              </Row>


              <Row>

                {/* CARD 1 */}
                <Col md={6}>
                  <FlipCard
                    frontContent={
                      <>
                        <div className='acheivements-icon'>
                          <img src={vision} alt="vision" className="img-icon" />
                        </div>
                        <div className='acheivements-content pt-4'>
                          <h3>Vision</h3>
                        </div>
                      </>
                    }
                    backContent={
                      <div className='acheivements-content pt-4'>
                        <h3>Our Vission</h3>
                        <p>To make home building in Chennai 100% transparent, tech-driven, and stress-free.</p>
                      </div>
                    }
                    className="acheivements-card mission-vission mb-4"
                    backBackgroundColor="#d7e4d5"
                  />
                </Col>

                {/* CARD 2 */}
                <Col md={6}>
                  <FlipCard
                    frontContent={
                      <>
                        <div className='acheivements-icon'>
                          <img src={mission} alt="mission" className="img-icon" />
                        </div>
                        <div className='acheivements-content pt-4'>
                          <h3>Mission</h3>
                        </div>
                      </>
                    }
                    backContent={
                      <div className='acheivements-content pt-4'>
                        <h3>Our Mission</h3>
                        <p> Deliver modern design, legal approvals, structural safety, and high-quality construction — all under one coordinated studio.</p>
                      </div>
                    }
                    className="acheivements-card mission-vission mb-4"
                    backBackgroundColor="#d7e4d5"
                  />
                </Col>
              </Row>

            </Col>
          </Row>


        </div>
      </Container>


      {/* Counter Design Section */}
      <section className="section">
        <div className="position-relative">
          {/* className="py-5 my-5" */}
          <div className="design-circle-about-us-counter position-absolute"></div>
          <Counter counterValues={homeCounterValue} />
        </div>
      </section>


      <section className="section">
        <Container>
          <div className="text-center">
            <h1 className="creative-learning-title">What Makes Us Different ? </h1>
            <p className="creative-learning-desc">At SDS, we're not just a design company; we're your trusted partner in construction and architecture excellence.</p>
          </div>

          <Row>
            {whyChoose.map((item, i) => (
              <Col xl={4} md={6} key={item.id}>
                <div className="creative-learning-card">
                  <div className="circle-icon">
                    <span className={item.icon} aria-hidden="true"></span>
                  </div>

                  <h2 className="creative-learning-card-title">{item.title}</h2>

                  <p className="creative-learning-card-desc">
                    {item.description}
                  </p>
                </div>
              </Col>
            ))}
          </Row>

          <div className="text-center my-md-4 pb-4 pb-md-0 mt-3">
            <Button 
              className="home-button mt-md-4 enroll-btns"
              onClick={() => navigate('/contact-us')}
            >
              Contact Us
            </Button>
          </div>
        </Container>
      </section>



      <section className="section">
        <div className="position-relative">
          <div className="text-center">
            <h1 className="creative-learning-title">Our Founders </h1>
            <p className="creative-learning-desc">Meet the visionaries behind SDS, whose minds have shaped our path towards excellence.</p>
          </div>
          <div className="design-circle-our-founder position-absolute"></div>
          <Container>
            <div className="founders-design postion-relative">

              <Row className="mb-5">
                <Col xl={4} className="text-center">
                  <div className="founder-img-wrapper">
                    <img src={Sathishkumar} alt="founder-img" className="founder-img" />
                  </div>
                  <h2 className="founder-name">Sathishkumar D</h2>
                  <p className="founder-designation mob-view">Founder & CEO, SDS LLC</p>
                </Col>
                <Col xl={8}>
                  <div className="founder-content">

                    <p>Sathishkumar D is the Founder and CEO of Sathiesh Design Studio (SDS), Chennai’s leading one-stop Architecture, Interior Design, Construction, and Plan Approval company. With 35 years of hands-on civil engineering experience, he has successfully led a wide range of residential, commercial, and institutional projects known for their aesthetic clarity, structural stability, and functional innovation.</p>
                    <p>A Diploma holder in Civil Engineering and a Registered Engineer with the Greater Chennai Corporation, Sathishkumar brings deep technical knowledge, practical site expertise, and strong rule-compliance understanding to every project. His specialization spans architectural planning, turnkey construction, interior design, structural coordination, and CMDA/DTCP approval-ready documentation.</p>
                    <strong>His vision for SDS is simple and powerful:</strong>
                    <p>to deliver homes that look beautiful, function intelligently, and stand strong for generations.</p>
                    <p>Through disciplined execution, vastu-aligned planning, accurate detailing, and transparent project management, he ensures every SDS project is designed with precision and built with integrity. Under his leadership, SDS has grown into Chennai’s first fully integrated Single-Window Design–Build Studio, offering modern design, engineering accuracy, and stress-free construction for clients across Tamil Nadu.</p>


                  </div>
                </Col>
              </Row>

              <Row className="mb-5 py-5">

                {/* IMAGE COLUMN — LEFT on mobile, RIGHT on desktop */}
                <Col
                  xs={12}
                  xl={4}
                  className="text-center order-1 order-xl-2"
                >
                  <div className="founder-img-wrapper">
                    <img src={saran} alt="founder-img" className="founder-img top-center" />
                  </div>
                  <h2 className="founder-name">Saran</h2>
                  <p className="founder-designation mob-view">Co-Founder SDS LLC</p>
                </Col>

                {/* CONTENT COLUMN — BELOW image on mobile, LEFT on desktop */}
                <Col
                  xs={12}
                  xl={8}
                  className="order-2 order-xl-1"
                >
                  <div className="founder-content">
                    <p>Saran is the Co-Founder of Sathiesh Design Studio (SDS) and a highly qualified engineering professional specializing in Structural Engineering, Construction Management, Rebar Design, Sustainable Building Systems, Laser Scanning, and Interior Design Integration. He holds an M.Tech in Structural Engineering & Construction Management, and is a certified LEED AP, bringing global sustainability standards into SDS projects.</p>

                    <p>With 5 years of diverse project experience, Saran has contributed to residential, commercial, and institutional developments, offering a blend of engineering precision and design sensitivity. He is a Registered Engineer with GCC, CMDA, and DTCP, delivering structurally sound and approval-compliant designs.</p>

                    <p>His expertise in Scan-to-BIM, structural coordination, and reinforcement design minimizes construction errors, optimizes material usage, and improves project timelines.</p>

                    <p>Focused on innovation and sustainability, Saran ensures SDS projects are strong, safe, and technologically advanced.</p>
                  </div>
                </Col>

              </Row>




              <Row >
                <Col xl={4} className="text-center">
                  <div className="founder-img-wrapper">
                    <img src={swetha} alt="founder-img" className="founder-img top-center" />
                  </div>
                  <h2 className="founder-name">Swetha Sathishkumar</h2>
                  <p className="founder-designation mob-view">Co-Founder & CEO, SDS LLC</p>
                </Col>
                <Col xl={8}>
                  <div className="founder-content">

                    <p>Swetha Sathishkumar is the Co-Founder of Sathiesh Design Studio (SDS) and a distinguished AEC professional with 15 years of experience in architecture, sustainable design, digital workflows, and innovative construction technologies. She holds an M.Arch, is a certified LEED AP, and a PMP-credentialed project management professional, bringing global design standards and technical leadership into SDS.</p>
                    <p>Swetha specializes in architectural design, laser scanning workflows, sustainability-driven planning, and AEC digital transformation. Her expertise plays a key role in integrating modern design principles with accurate measurement technologies, climate-responsive strategies, and environmentally conscious decision-making across all SDS projects.</p>
                    <p>A strong advocate for women’s leadership in the AEC industry, Swetha focuses on creating a workplace that encourages equal opportunity, innovation, and professional growth. Her intention is to collaborate with organizations on smart, sustainable, and future-ready AEC practices while paving the path for women to excel in technical and leadership roles.</p>
                    <p>Her multi-disciplinary skill set allows her to streamline architecture, BIM processes, laser scanning, VR-based communication, and sustainable development, ensuring every SDS project is design-rich, data-driven, and environmentally responsible.</p>
                    <p>Her multi-disciplinary skill set allows her to streamline architecture, BIM processes, laser scanning, VR-based communication, and sustainable development, ensuring every SDS project is design-rich, data-driven, and environmentally responsible.</p>
                    <p>Architects • Interior Designers • Project Managers • Structural Engineers • MEP Consultants • Construction Supervisors • Approval Experts</p>

                  </div>
                </Col>
              </Row>

            </div>
          </Container>
        </div>
      </section>


      {/* <section className="section">
          <div className="position-relative">
            <div className="design-circle-about-us-counter position-absolute"></div>
              <--* Our Placement Companies *-->
              <Placement />
          </div>
        </section> */}

      {/* <section className="section">
        <Faq show="true" />
        <div className="text-center my-md-4 pb-4 pb-md-0 mt-3">
          <Button 
            className="home-button mt-md-4 enroll-btns"
            backgroundColor="#677a58"
            color="#ffffff"
            hoverBackgroundColor="#5a6a4a"
            padding="13px 40px"
            fontSize="16px"
            fontWeight="500"
            borderRadius="100px"
            onClick={() => navigate('/faq')}
          >
            Show More
          </Button>
        </div>
      </section> */}

    </div>
  )
}

export default AboutUs;